import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/TermsOfUse.css';

const TermsOfUse = () => {
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            
            <div className="terms-nav">
                <button onClick={() => navigate(-1)} className="back-link">← Back</button>
            </div>
            <div className="terms-container">
                
                <div className="terms-header">
                    <div className="terms-title">Terms of Use</div>
                    <div className="last-updated">Last Updated: December 1, 2025</div>
                </div>
                
                <div className="terms-intro">
                    <div className="terms-text">Welcome to Autocommitter. By accessing or using our application, you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our service.</div>
                </div>

                <div className="terms-divider"></div>

                <div id="description" className="terms-section">
                    <div className="terms-subtitle">1. Description of Service</div>
                    <div className="terms-text">Autocommitter is a tool designed to allow users to visualize and manipulate their GitHub contribution graph by creating empty commits. The service is provided "as is" and is intended for educational and aesthetic purposes.</div>
                </div>

                <div id="user-obligations" className="terms-section">
                    <div className="terms-subtitle">2. User Obligations</div>
                    <div className="terms-text">By using Autocommitter, you agree to:</div>
                    <div className="terms-list">
                        <div className="terms-list-item">Provide accurate and complete information when connecting your GitHub account.</div>
                        <div className="terms-list-item">Maintain the security of your GitHub account credentials.</div>
                        <div className="terms-list-item">Accept full responsibility for all activities that occur under your account.</div>
                    </div>
                </div>

                <div id="prohibited-uses" className="terms-section">
                    <div className="terms-subtitle">3. Prohibited Uses</div>
                    <div className="terms-text">You agree not to use Autocommitter for any of the following purposes:</div>
                    <div className="terms-list">
                        <div className="terms-list-item">To manipulate GitHub's contribution graph for deceptive purposes or to misrepresent your actual coding activity in a professional context.</div>
                        <div className="terms-list-item">To violate GitHub's Terms of Service or Acceptable Use Policies.</div>
                        <div className="terms-list-item">To disrupt or interfere with the security or performance of the application.</div>
                        <div className="terms-list-item">To use the service for any illegal or unauthorized purpose.</div>
                    </div>
                </div>

                <div id="disclaimer" className="terms-section">
                    <div className="terms-subtitle">4. Disclaimer of Warranties</div>
                    <div className="terms-text"><strong>Autocommitter is provided on an "AS IS" and "AS AVAILABLE" basis.</strong> We make no warranties, expressed or implied, regarding the operation of the service or the information, content, or materials included therein. To the full extent permissible by applicable law, we disclaim all warranties, including but not limited to implied warranties of merchantability and fitness for a particular purpose.</div>
                </div>

                <div id="limitation-of-liability" className="terms-section">
                    <div className="terms-subtitle">5. Limitation of Liability</div>
                    <div className="terms-text">Autocommitter and its developers shall not be liable for any damages of any kind arising from the use of this service, including but not limited to direct, indirect, incidental, punitive, and consequential damages. <strong>We are not responsible for any actions taken by GitHub against your account, including suspension or termination, resulting from your use of this tool.</strong> Use this tool at your own risk.</div>
                </div>

                <div id="intellectual-property" className="terms-section">
                    <div className="terms-subtitle">6. Intellectual Property</div>
                    <div className="terms-text">The content, design, and code of Autocommitter are the property of the developers and are protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without express permission.</div>
                </div>

                <div id="changes" className="terms-section">
                    <div className="terms-subtitle">7. Changes to Terms</div>
                    <div className="terms-text">We reserve the right to modify these Terms of Use at any time. Any changes will be effective immediately upon posting on this page. Your continued use of the service after any changes constitutes your acceptance of the new terms.</div>
                </div>

                <div id="contact" className="terms-section">
                    <div className="terms-subtitle">8. Contact Us</div>
                    <div className="terms-text">If you have any questions about these Terms of Use, please contact us via the repository issues page.</div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfUse;
